<template>
  <div class="navbar">
    <canvas ref="starCanvas" class="star-canvas"></canvas>
    <template>
      <div class="logo" />
    </template>
    <el-menu
      :router="true"
      :default-active="currentPath"
      class="el-menu-demo"
      background-color="transparent"
      text-color="#fff"
      active-text-color="#fff"
      @select="handleRoute"
    >
      <el-menu-item index="/">
        <i class="el-icon-s-home"></i>学员中心</el-menu-item
      >
      <el-menu-item index="test">
        <i class="el-icon-document-checked"></i>测评中心</el-menu-item
      >
      <el-menu-item index="exam">
        <i class="el-icon-document"></i>真题演练</el-menu-item
      >
      <el-menu-item index="rank">
        <i class="el-icon-trophy"></i>书克赛事</el-menu-item
      >
      <el-menu-item index="class"
        ><i class="el-icon-s-custom"></i>我的班级</el-menu-item
      >
      <el-menu-item index="question"
        ><i class="el-icon-service"></i>
        <el-badge
          v-if="questionMsg > 0"
          :value="questionMsg"
          :max="99"
          class="custom-badge"
        >
          答疑中心
        </el-badge>
        <span v-else>答疑中心</span>
      </el-menu-item>
      <el-menu-item index="mistakeNotebook"
        ><i class="el-icon-document-delete"></i>我的错题</el-menu-item
      >
      <el-submenu index="problem">
        <template slot="title">
          <i class="el-icon-notebook-1"></i><span>题库列表</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="objectiveProblems"
            ><span>客观题</span></el-menu-item
          >
          <el-menu-item index="problems"><span>编程题</span></el-menu-item>
          <el-menu-item @click="goSharpCode"
            ><span>拓展题库</span></el-menu-item
          >
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item index="skRank"
        ><i class="el-icon-s-data"></i>书克排名</el-menu-item
      >
      <el-menu-item index="download"
        ><i class="el-icon-download"></i>软件下载</el-menu-item
      >
    </el-menu>
  </div>
</template>

<script>
import api from "@/apis/api";
import { mapGetters, mapActions } from "vuex";
import store from "@/store";

export default {
  data() {
    return {
      currentPath: "/",
      stars: [],
      animationFrameId: null,
      canvas: null,
      ctx: null,
      resizeTimer: null,
    };
  },
  computed: {
    ...mapGetters("questionMsg", ["questionMsg", "hasNewMsg"]),
  },
  mounted() {
    this.initStarCanvas();

    const userDetail = store.state.user.studentUserInfo;
    if (userDetail && userDetail.stage == "在学学员") {
      this.fetchQuestionMsg();
      const POLLING_INTERVAL = 30 * 1000;
      this.pollingTimer = setInterval(() => {
        this.fetchQuestionMsg();
      }, POLLING_INTERVAL);
    }
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    if (this.pollingTimer) {
      clearInterval(this.pollingTimer);
    }
    this.destroyStarCanvas();
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    ...mapActions("questionMsg", ["fetchQuestionMsg"]),
    handleRoute(index) {
      this.currentPath = index;
    },
    goSharpCode() {
      window.open(api.hydraBaseUrl, "_blank");
    },
    initStarCanvas() {
      this.canvas = this.$refs.starCanvas;
      if (!this.canvas) return;

      this.ctx = this.canvas.getContext("2d");
      if (!this.ctx) return;
      this.resizeCanvas();
      this.createStars(80);
      this.animateStars();
    },
    resizeCanvas() {
      if (!this.canvas) return;
      const navbar = this.$el;
      this.canvas.width = navbar.offsetWidth;
      this.canvas.height = navbar.offsetHeight;
    },

    /**
     * 创建随机星星
     * @param {number} count - 星星数量
     */
    createStars(count) {
      this.stars = [];
      const navbar = this.$el;
      const width = navbar.offsetWidth;
      const height = navbar.offsetHeight;

      for (let i = 0; i < count; i++) {
        const speed = Math.random() * 0.1 + 0.1;
        const angle = Math.random() * Math.PI * 2;

        this.stars.push({
          x: Math.random() * width,
          y: Math.random() * height,
          radius: Math.random() * 1.5 + 0.5,
          opacity: Math.random(),
          twinkleSpeed: Math.random() * 0.02 + 0.01,
          twinkleDirection: Math.random() > 0.5 ? 1 : -1,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed,
          speed: speed,
          angle: angle,
        });
      }
    },
    animateStars() {
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      this.drawStars();
      this.animationFrameId = requestAnimationFrame(() => {
        this.animateStars();
      });
    },
    drawStars() {
      this.stars.forEach((star) => {
        star.opacity += star.twinkleSpeed * star.twinkleDirection;
        if (star.opacity > 1) {
          star.opacity = 1;
          star.twinkleDirection = -1;
        } else if (star.opacity < 0.1) {
          star.opacity = 0.1;
          star.twinkleDirection = 1;
        }
        star.x += star.vx;
        star.y += star.vy;
        const margin = 10;
        if (star.x < -margin) {
          star.x = this.canvas.width + margin;
        } else if (star.x > this.canvas.width + margin) {
          star.x = -margin;
        }

        if (star.y < -margin) {
          star.y = this.canvas.height + margin;
        } else if (star.y > this.canvas.height + margin) {
          star.y = -margin;
        }
        this.ctx.save();
        this.ctx.globalAlpha = star.opacity;
        this.ctx.fillStyle = "#ffffff";
        this.ctx.beginPath();
        this.ctx.arc(star.x, star.y, star.radius, 0, Math.PI * 2);
        this.ctx.fill();
        this.ctx.restore();
      });
    },
    handleResize() {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
      }

      this.resizeTimer = setTimeout(() => {
        this.resizeCanvas();
        this.createStars(80);
      }, 200);
    },
    destroyStarCanvas() {
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
      }
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
      }
      this.stars = [];
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .custom-badge .el-badge__content {
  margin-right: -30px;
  transform: translateY(18px);
  font-size: 12px;
  padding: 0 4px 0 4px;
  height: 18px;
  line-height: 18px;
}
.navbar {
  height: 100vh;
  overflow: hidden;
  position: relative;

  .star-canvas {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    pointer-events: none;
  }

  .el-menu-demo {
    background-color: transparent;
    border: none;
    text-align: center;
    margin-top: 10px;
    position: relative;
    z-index: 1;
  }

  .logo {
    background: url("@/assets/images/footerlogo.png");
    margin: 10px 0 10px -70px;
    width: 325px;
    height: 40px;
    line-height: 40px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    cursor: pointer;
  }

  .el-submenu {
    font-size: 16px;
    color: #fff;
    letter-spacing: 0.1rem;
    text-align: center;
    background-color: transparent;

    i {
      color: #fff;
      font-size: 16px;
    }

    span {
      color: #fff;
      font-size: 16px;
    }

    .el-menu-item-group {
      margin-top: -15px;
      font-size: 16px;
      background-color: transparent;

      span {
        margin-left: 10px;
      }
    }
  }
  ::v-deep .el-menu-item {
    background-color: transparent !important;
    /* 保持hover动画但移除颜色变化 */
    &:hover,
    &:focus,
    &.is-active {
      background-color: transparent !important;
      color: #fff !important;
      i {
        color: #fff !important;
        text-shadow: 0 1px 0 rgba(255, 255, 255, 0.4),
          0 2px 0 rgba(0, 0, 0, 0.3), 0 3px 0 rgba(0, 0, 0, 0.2),
          0 4px 0 rgba(0, 0, 0, 0.1), 0 6px 8px rgba(0, 0, 0, 0.3);
      }
    }
  }

  /* 统一子菜单样式 */
  ::v-deep .el-submenu {
    /* 3D立体文字效果 */
    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.3), 0 2px 0 rgba(0, 0, 0, 0.2),
      0 3px 0 rgba(0, 0, 0, 0.1), 0 4px 0 rgba(0, 0, 0, 0.05),
      0 5px 5px rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease;

    &:hover,
    &.is-hover,
    &.is-opened,
    &.is-active {
      background-color: transparent !important;
      color: #fff !important;
      border: none !important;
      text-shadow: 0 1px 0 rgba(255, 255, 255, 0.4), 0 2px 0 rgba(0, 0, 0, 0.3),
        0 3px 0 rgba(0, 0, 0, 0.2), 0 4px 0 rgba(0, 0, 0, 0.1),
        0 6px 8px rgba(0, 0, 0, 0.3);
      i {
        color: #fff !important;
        text-shadow: 0 1px 0 rgba(255, 255, 255, 0.4),
          0 2px 0 rgba(0, 0, 0, 0.3), 0 3px 0 rgba(0, 0, 0, 0.2),
          0 4px 0 rgba(0, 0, 0, 0.1), 0 6px 8px rgba(0, 0, 0, 0.3);
      }
    }
  }

  ::v-deep .el-submenu__title {
    background-color: transparent !important;
    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.3), 0 2px 0 rgba(0, 0, 0, 0.2),
      0 3px 0 rgba(0, 0, 0, 0.1), 0 4px 0 rgba(0, 0, 0, 0.05),
      0 5px 5px rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease;
    color: #fff;

    i {
      color: #fff;
      font-size: 16px;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
      transition: all 0.3s ease;
    }

    span {
      color: #fff;
    }

    &:hover,
    &:focus,
    &.is-active {
      background-color: transparent !important;
      color: #fff !important;
      border: none !important;
      outline: none !important;
      /* 恢复悬停动画效果 */
      text-shadow: 0 1px 0 rgba(255, 255, 255, 0.4), 0 2px 0 rgba(0, 0, 0, 0.3),
        0 3px 0 rgba(0, 0, 0, 0.2), 0 4px 0 rgba(0, 0, 0, 0.1),
        0 6px 8px rgba(0, 0, 0, 0.3);
      i {
        color: #fff !important;
        text-shadow: 0 1px 0 rgba(255, 255, 255, 0.4),
          0 2px 0 rgba(0, 0, 0, 0.3), 0 3px 0 rgba(0, 0, 0, 0.2),
          0 4px 0 rgba(0, 0, 0, 0.1), 0 6px 8px rgba(0, 0, 0, 0.3);
      }

      span {
        color: #fff !important;
      }
    }
  }

  ::v-deep .el-submenu__popup {
    background-color: rgba(10, 25, 47, 0.85) !important;
    backdrop-filter: blur(10px);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2) !important;
    border-radius: 8px !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
  }
  ::v-deep .el-submenu__popup .el-menu {
    background-color: transparent !important;
    .el-menu-item-group {
      background-color: transparent !important;
      .el-menu-item {
        text-shadow: 0 1px 0 rgba(255, 255, 255, 0.3),
          0 2px 0 rgba(0, 0, 0, 0.2), 0 3px 0 rgba(0, 0, 0, 0.1),
          0 4px 0 rgba(0, 0, 0, 0.05), 0 5px 5px rgba(0, 0, 0, 0.2);
        transition: all 0.3s ease;
        color: #fff !important;
        background-color: transparent !important;

        span {
          color: #fff !important;
        }

        &:hover,
        &:focus,
        &.is-active {
          background-color: transparent !important;
          color: #fff !important;
          text-shadow: 0 1px 0 rgba(255, 255, 255, 0.4),
            0 2px 0 rgba(0, 0, 0, 0.3), 0 3px 0 rgba(0, 0, 0, 0.2),
            0 4px 0 rgba(0, 0, 0, 0.1), 0 6px 8px rgba(0, 0, 0, 0.3);
          span {
            color: #fff !important;
          }
        }
      }
    }
  }

  ::v-deep .el-submenu__icon-arrow {
    font-size: 15px;
    color: #fff;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
    .el-submenu:hover &,
    .el-submenu.is-opened & {
      color: #fff !important;
      text-shadow: 0 1px 0 rgba(255, 255, 255, 0.4), 0 2px 0 rgba(0, 0, 0, 0.3),
        0 3px 0 rgba(0, 0, 0, 0.2), 0 4px 0 rgba(0, 0, 0, 0.1),
        0 6px 8px rgba(0, 0, 0, 0.3);
    }
  }
  .el-menu-item {
    font-size: 16px;
    color: #fff;
    letter-spacing: 0.1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    background-color: transparent !important;
    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.3), 0 2px 0 rgba(0, 0, 0, 0.2),
      0 3px 0 rgba(0, 0, 0, 0.1), 0 4px 0 rgba(0, 0, 0, 0.05),
      0 5px 5px rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease;

    i {
      color: #fff;
      font-size: 16px;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
    }

    &:hover,
    &.is-active {
      color: #fff !important;
      text-shadow: 0 1px 0 rgba(255, 255, 255, 0.4), 0 2px 0 rgba(0, 0, 0, 0.3),
        0 3px 0 rgba(0, 0, 0, 0.2), 0 4px 0 rgba(0, 0, 0, 0.1),
        0 6px 8px rgba(0, 0, 0, 0.3);
      i {
        color: #fff !important;
        text-shadow: 0 1px 0 rgba(255, 255, 255, 0.4),
          0 2px 0 rgba(0, 0, 0, 0.3), 0 3px 0 rgba(0, 0, 0, 0.2),
          0 4px 0 rgba(0, 0, 0, 0.1), 0 6px 8px rgba(0, 0, 0, 0.3);
      }
    }
  }
}
</style>
